import { Icon } from 'components/ui/Icon/Icon';
import creditCardIcons from 'icons/credit-card-icons.svg';

const CreditCardIcon = ({ name }: { name: string }) => {
  return <Icon name={`${creditCardIcons}#${name}`} />;
};

export { CreditCardIcon };
